const steps = [
  {
    number: '1',
    icon: 'ri-file-text-line',
    title: 'Tell Us About Your Car',
    description:
      'Fill out our consignment form with your vehicle details and what you\'re hoping to get for it. We\'ll review everything and get back to you within 24 hours — not "sometime next week."',
  },
  {
    number: '2',
    icon: 'ri-camera-line',
    title: 'We Make It Look Good',
    description:
      'We detail, photograph, and write a listing that actually sells your car — not a three-word description with one blurry photo. Then we push it across every platform buyers actually use.',
  },
  {
    number: '3',
    icon: 'ri-user-search-line',
    title: 'We Handle the Strangers',
    description:
      'Inquiries, showings, test drives, negotiations — all us. You won\'t have to meet a single tire-kicker or field a 11pm text asking "will you take $500 less?"',
  },
  {
    number: '4',
    icon: 'ri-hand-coin-line',
    title: 'You Get Paid',
    description:
      'Car sold, paperwork done, title transferred — all handled. You get a check for your agreed amount minus our flat fee. Simple math, no surprises.',
  },
];

export default function ConsignmentHowItWorks() {
  return (
    <section className="py-20 bg-[#F7F5F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Oswald'] text-4xl md:text-5xl font-bold text-[#1C2B1E] mb-4">
            How It Works (It's Embarrassingly Simple)
          </h2>
          <div className="w-24 h-1 bg-[#E8B84B] mx-auto mb-6"></div>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: '#374151' }}>
            You drop off the car. We do the work. You get retail money. That's genuinely the whole thing.
          </p>
        </div>

        <ol className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 list-none" aria-label="Consignment process steps">
          {steps.map((step, index) => (
            <li key={index} className="relative">
              {index < steps.length - 1 && (
                <div aria-hidden="true" className="hidden lg:block absolute top-16 left-[60%] w-[80%] h-0.5 bg-[#E8E2D6]"></div>
              )}

              <div className="relative bg-white rounded-2xl p-8 border-2 border-[#E8E2D6] hover:border-[#E8B84B] transition-all text-center">
                <div aria-hidden="true" className="absolute -top-4 left-1/2 -translate-x-1/2 w-12 h-12 bg-[#1C2B1E] text-white rounded-full flex items-center justify-center font-['Oswald'] text-2xl font-bold">
                  {step.number}
                </div>

                <div className="w-20 h-20 bg-[#E8B84B] rounded-full flex items-center justify-center mx-auto mb-6 mt-4">
                  <i className={`${step.icon} text-4xl text-[#1C2B1E]`} aria-hidden="true"></i>
                </div>

                <h3 className="font-['Oswald'] text-2xl font-bold text-[#1C2B1E] mb-3">
                  {step.title}
                </h3>
                <p style={{ color: '#374151' }} className="leading-relaxed">{step.description}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-12 text-center">
          <p className="text-sm italic mb-4" style={{ color: '#4A5568' }}>Most consignment vehicles sell within 30–45 days. We aim to turn the whole lot in 60.</p>
          <a href="#consignment-form" className="inline-flex items-center gap-2 bg-[#1C2B1E] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#2d4430] transition-all whitespace-nowrap cursor-pointer">
            Start the Process
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
